export default {
  allBankBalances: [],
}
